import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";

import { careersPath } from "./lib/paths";
import ApplyPage from "./pages/ApplyPage";
import CareersHome from "./pages/CareersHome";
import JobPage from "./pages/JobPage";

// Public careers portal, mounted at /careers/* for signed-in and signed-out
// visitors alike.
export default function CareersRoutes() {
  return (
    <Routes>
      <Route index element={<CareersHome />} />
      <Route path=":slug" element={<JobPage />} />
      <Route path=":slug/apply" element={<ApplyPage />} />
      <Route path="*" element={<Navigate to={careersPath()} replace />} />
    </Routes>
  );
}

// Links to the old portal (/job-view, /job-view/:id, /job-apply/:id) are out
// in the wild: in WhatsApp chats, job boards and printed QR codes. They open
// the same role in the new portal. :id may be a slug or a numeric job id;
// the API accepts both.
export function LegacyJobRedirect({ apply = false }) {
  const { id } = useParams();
  const { search } = useLocation();
  const to = id ? careersPath(id, apply ? "apply" : "") : careersPath();
  return <Navigate to={`${to}${search}`} replace />;
}
